export const AcceptedImageTypes = ['image/jpeg', 'image/png'];
export const EditorImageMaxWidth = 736;
export const EditorUploadMaxSize = 2 * 1024 * 1024; // 2MB
export const ImportDocumentMaxSize = 100 * 1024 * 1024; // 100MB
